interface ArrowProps {
  children?: JSX.Element;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
  focus?: boolean;
}

function CustomArrowWrapper(props: ArrowProps) {
  const { children, className, onClick, hover = true, focus } = props;
  if (!onClick) {
    return null;
  }

  return (
    <button
      tabIndex={-1}
      data-hook="carousel-arrow"
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.();
      }}
      style={{
        opacity: hover || focus ? 1 : 0,
      }}
    >
      {children}
    </button>
  );
}

export default CustomArrowWrapper;
